/* eslint-disable */
export default {
  unknown: 'Desconocido',
  multipleMatches: 'Varias coincidencias',
  anonymous: 'Anónimo',
  none: 'Ninguno',
} as const;

// @key: @#@"unknown"@#@ @source: @#@"Unknown"@#@
// @key: @#@"multipleMatches"@#@ @source: @#@"Multiple matches"@#@
// @key: @#@"anonymous"@#@ @source: @#@"Anonymous"@#@
// @key: @#@"none"@#@ @source: @#@"None"@#@
